import type { ComponentType } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import type { Location, NavigateFunction, Params } from 'react-router';

/** What withRouter injects: the react-router v6+ hooks, as one `router` prop. */
type RouterProps = {
  router: {
    location: Location;
    navigate: NavigateFunction;
    params: Readonly<Params<string>>;
  };
};

const withRouter = <P extends RouterProps>(WrappedComponent: ComponentType<P>) => {
  const ComponentWithRouter = (props: Omit<P, 'router'>) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <WrappedComponent
        // The one cast: TypeScript cannot prove that Omit<P, 'router'> plus
        // `router` is P again for a generic P, although it is.
        {...(props as P)}
        router={{ location, navigate, params }}
      />
    );
  };

  return ComponentWithRouter;
};

export default withRouter;
